<template>
    <div>
        <span class="text-helper">{{ tvPackage.name }}</span>
        <div v-if="tvPackage.has_campaign">
            <div class="mt-xs text-lg font-extrabold text-ownit-red">
                {{ getCampaignPrice(tvPackage) }}
            </div>
            <div class="text-sm mt-xs mb-md">
                {{ getCampaignAfterPrice(tvPackage) }}
            </div>
        </div>
        <div v-else>
            <div class="mt-xs text-lg font-extrabold">
                {{ format_sek_per_month(tvPackage.monthly_price) }}
            </div>
        </div>
        <div class="mt-sm mb-2xl text-md text-neutral-dark">
            {{ tvPackage.description }}
        </div>
        <div class="mt-xl sm:mx-lg lg:mx-2xl mb-0">
            <ul class="text-sm text-neutral-dark text-left font-bold">
                <li>
                    <span>{{ tvChannels }} {{ tvChannels > 1 ? lang('TV-kanaler','TV channels') : lang('TV-kanal','TV channel') }}</span>
                </li>
                <li v-if="tvPackage.is_flex && tvPackage.flex_channels.length" class="mt-sm">
                    8 ({{ lang('av', 'of') }} {{ tvPackage.flex_channels.length }}) {{ lang('valbara kanaler','selectable channels') }}
                </li>
                <li v-if="tvPackage.play_channels.length" class="mt-sm">
                    {{ tvPackage.play_channels.length }}
                    {{ tvPackage.play_channels.length > 1 ? lang('Playkanaler','Play channels') : lang('Playkanal','Play channel') }}
                </li>
                <li v-if="hasIncludedStreamPackages && includedStreamPackagesNames" class="mt-sm">
                    {{ includedStreamPackagesNames }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import TvChannelsMixin from './TvChannelsMixin';

    export default {
        mixins: [TvChannelsMixin],
        props: {
            tvPackage: {
                type: Object,
                required: true,
            },
        },
        computed: {
            includedStreamPackagesNames() {
                return this.tvPackage.included_stream_packages || '';
            },
        },
        methods: {
            hasIncludedStreamPackages() {
                return this.tvPackage.included_stream_packages;
            },
            getCampaignPrice(tvPackage) {
                const campaign = tvPackage.campaigns[0];
                return format_sek_per_month(campaign.discounted_monthly_price) + ' '
                    + lang(`i ${campaign.discount_months} månader`, `for ${campaign.discount_months} months`);
            },
            getCampaignAfterPrice(tvPackage) {
                const campaign = tvPackage.campaigns[0];

                return lang('Därefter', 'Then') + ' ' + format_sek_per_month(campaign.monthly_price);
            },
        },
    };
</script>
